import { dividerSettingsSchema } from "../../../email-design/types/email-divider-settings";

import type {
  DividerSettings,
  DividerTemplate,
} from "../../../email-design/types/email-divider-settings";
import type { InsertDividerCommand } from "./commands";
import type { DeepPartial } from "react-hook-form";

/** Style set on one divider in a communication. Unset fields fall back to the email design. */
export type DividerStyleOverride = Partial<DividerTemplate>;

export type ChangeDividerStyle = (change: DividerStyleOverride, skipHistory: boolean) => void;

type DividerType = NonNullable<InsertDividerCommand>["type"];

const defaultDividerSettings = dividerSettingsSchema.getDefault();

/** The style a divider renders with: its own override, then the email design, then the schema default. */
export function resolveDividerStyle(options: {
  type: DividerType;
  dividers: DeepPartial<DividerSettings> | null;
  override: DividerStyleOverride;
}): DividerTemplate {
  const { type, dividers, override } = options;
  const fallback = defaultDividerSettings[type];
  const template = dividers?.[type];

  return {
    color: override.color ?? template?.color ?? fallback.color,
    width: override.width ?? template?.width ?? fallback.width,
    style: override.style ?? template?.style ?? fallback.style,
  };
}
